import RulesUtils from './RulesUtils'

export default RulesUtils